import { z } from 'zod';
export const sidebarSavedViewSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    color: z.string(),
    count: z.number().int(),
});
export const sidebarCountsResponseSchema = z.object({
    leads: z.number().int(),
    tasks: z.number().int(),
    savedViews: z.array(sidebarSavedViewSchema),
});
/** A workspace member option for "assign to" pickers (leads/deals/tasks) —
 * just who's active in the tenant, not an admin-only listing, so it's
 * exposed under `/me` (no special permission — knowing your teammates'
 * names isn't sensitive) rather than reusing the admin users endpoint. */
export const assignableMemberSchema = z.object({
    id: z.string().uuid(),
    displayName: z.string(),
    /** Two members can share a display name — this is how "assign to" pickers
     * tell them apart (`disambiguateNames`, apps/web/src/lib) when that
     * happens, shown only for the colliding names, not every row. */
    email: z.string().email(),
});
//# sourceMappingURL=schemas.js.map